<div class="content">
  <div fxLayout="column" fxLayoutGap="5px">
    <div class="tag" fxLayout="column" fxLayoutGap="5px">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div class="headline">
          <h3 class="title"></h3>
        </div>
        <ng-container *ngIf="isAdmin">
          <div fxLayoutAlign="end">
            <button mat-button color="primary" (click)="openEditTagsDialog()">
              <mat-icon class="text-icon" aria-label="">border_color</mat-icon>
              {{ "settingsTags.edit" | translate }}
            </button>
          </div>
        </ng-container>
      </div>
      <div>
        <mat-table #modeltable [dataSource]="tagListDataSource" fxFlex>
          <ng-container matColumnDef="tags">
            <mat-header-cell *matHeaderCellDef>{{ tagsLabel }}</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row }} </mat-cell>
          </ng-container>
          <mat-header-row
            *matHeaderRowDef="displayedTagColumns"
          ></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedTagColumns"></mat-row>
        </mat-table>
      </div>
    </div>
  </div>
</div>
